import { HStack } from '@chakra-ui/react';
import styled from '../../consts/styled';

import { colors, media, PRIMARY_FONT_FAMILY, spacing } from '../../App/ChakraTheme';

export const Container = styled(HStack)`
  & > ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: ${spacing.BASE} 0;
    ${media.phone`
      height: 32px;
      align-items: center;
      cursor: pointer;
    `};
  }
  & > ul li {
    fontFamily: ${PRIMARY_FONT_FAMILY},
    fontSize: 12px,
    fontWeight: bold,
    fontStyle: normal,
    fontStrech: normal,
    lineHeight: 1.33,
    color: ${colors.midnight};
    margin-left: ${spacing.LARGE};
    cursor: pointer;
    opacity: 0.7;
    will-change: opacity;
    transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1);
    ${media.phone`
      margin-right: ${spacing.TINY};
      opacity: 1;
    `};
  }
  & > ul li .caption {
    color: ${colors.midnight};
  }
  & > ul li.active {
    opacity: 1;
    padding-bottom: ${spacing.TINY};
    border-bottom: 3px solid ${colors.midnight};
  }
  & > ul li:hover {
    opacity: 1;
  }
  & > ul li:focus-visible {
    outline: 2px solid #3182ce;
    outline-offset: 2px;
    border-radius: 2px;
    opacity: 1;
  }
  & > ul li:first-child {
    margin-left: 0;
  }

  & .hide-phone {
    ${media.phone`
      display: none;
    `};
  }
  & .show-phone {
    display: none;
    ${media.phone`
      display: flex;
    `};
  }

  & > ul li.disabled {
    // jebemu mater :)
    cursor: not-allowed;
    
    p {
      color: #adadad !important;
    }
  }
`;
